/* Main Product — behaviour for sections/main-product.liquid
   Split out of the section so the section file stays under Shopify's ~256KB
   per-file limit, and so the browser can cache this across product pages.
   Everything that used to be interpolated by Liquid now arrives through the
   [data-pdp-config] JSON island rendered inside the section. */
(function(){
  function initPdp(root){
    if (root.dataset.pdpInitialized === 'true') return;
    root.dataset.pdpInitialized = 'true';
    var sectionId = root.getAttribute('data-section-id');
    var colors = JSON.parse(root.dataset.colors || '[]');
    var sizes = JSON.parse(root.dataset.sizes || '[]');
    var variantMap = JSON.parse(root.dataset.variants || '{}');
    var productUrl = root.dataset.productUrl;
    var variantBlock = root.querySelector('[data-pdp-swatch-map]');
    var swatchMap = {};
    if (variantBlock) {
      var raw = variantBlock.getAttribute('data-pdp-swatch-map') || '';
      raw.split('|LINE|').forEach(function(line){
        line = line.trim();
        if (line.indexOf(':') > -1) {
          var parts = line.split(':');
          swatchMap[parts[0].trim().toLowerCase()] = parts[1].trim();
        }
      });
    }
    var mainImgWrap = root.querySelector('[data-pdp-main-img]');
    var colorsWrap = root.querySelector('[data-pdp-colors]');
    var colorLabel = root.querySelector('[data-pdp-color-label]');
    var sizesWrap = root.querySelector('[data-pdp-sizes]');
    var sizeSelect = root.querySelector('[data-pdp-size-select]');
    var sizeLabel = root.querySelector('[data-pdp-size-label]');
    var priceNowEl = root.querySelector('[data-pdp-price-now]');
    var priceWasEl = root.querySelector('[data-pdp-price-was]');
    var priceSavePill = root.querySelector('[data-pdp-price-save-pill]');
    // Only present in the "value comparison" layout; every use below is guarded.
    var compareBox = root.querySelector('[data-pdp-price-compare]');
    var compareCol = root.querySelector('[data-pdp-compare-col]');
    var compareAtEl = root.querySelector('[data-pdp-price-compare-at]');
    var saveCaption = root.querySelector('[data-pdp-save-caption]');
    // The tag reference is one number for the whole product, so it is read once
    // here; only the asking price it is compared against changes per variant.
    var refFromTag = compareBox ? (parseInt(compareBox.getAttribute('data-ref-price'), 10) || 0) : 0;
    var refIsTag = !!compareBox && compareBox.getAttribute('data-ref-source') === 'tag';
    var saveBadge = root.querySelector('[data-pdp-save-badge]');
    var paymentNoteEl = root.querySelector('[data-pdp-payment-note]');
    var stockItem = root.querySelector('[data-pdp-stock-item]');
    var stockText = root.querySelector('[data-pdp-stock-text]');
    var stockBar = root.querySelector('[data-pdp-stock-bar]');
    var atcBtn = root.querySelector('[data-pdp-atc]');
    var atcText = root.querySelector('[data-pdp-atc-text]');
    var atcPrice = root.querySelector('[data-pdp-atc-price]');
    var stickyBar = document.querySelector('[data-pdp-sticky-bar]');
    var stickyThumb = stickyBar ? stickyBar.querySelector('[data-pdp-sticky-thumb]') : null;
    var stickyPrice = stickyBar ? stickyBar.querySelector('[data-pdp-sticky-price]') : null;
    var stickyAtc = stickyBar ? stickyBar.querySelector('[data-pdp-sticky-atc]') : null;
    var stickyAtcText = stickyBar ? stickyBar.querySelector('[data-pdp-sticky-atc-text]') : null;
    var selectedColor = '';
    var selectedSize = '';
    var currentVariant = null;
    // Everything Liquid needs to hand the script lives in one JSON island inside
    // the section root, so this file can be a plain cached asset instead of being
    // re-rendered inline on every product page.
    var CFG = {};
    var cfgEl = root.querySelector('[data-pdp-config]');
    if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; } }
    var ADD_TO_BAG_TEXT = CFG.addToBag || 'Add to bag';
    var SOLD_OUT_TEXT = CFG.soldOut || 'Sold out';
    var SAVE_BADGE_PREFIX = CFG.saveBadgePrefix || 'Save';
    var LOW_STOCK_THRESHOLD = CFG.lowStockThreshold || 10;
    var STOCK_LOW_TEXT = CFG.stockLow || 'left — selling fast';
    var STOCK_IN_TEXT = CFG.stockIn || 'In stock';
    var STOCK_OUT_TEXT = CFG.stockOut || 'Out of stock';
    var STOCK_SELECT_TEXT = CFG.stockSelect || 'Select options';
    var UNTRACKED_FILL_PERCENT = CFG.untrackedFill || 70;
    var PAYMENT_INSTALLMENTS = CFG.installments || 4;
    var PAYMENT_PREFIX = CFG.payPrefix || 'Or';
    var PAYMENT_MIDDLE = CFG.payMiddle || 'interest-free payments of';
    var PAYMENT_SUFFIX = CFG.paySuffix || '.';
    var SAVINGS_PREFIX = CFG.savingsPrefix || 'You save';
    var SAVINGS_FORMAT = CFG.savingsFormat || 'percent';
    var CART_ADD_URL = CFG.cartAddUrl || '/cart/add';
    var ADDED_TEXT = CFG.addedText || 'Added!';
    var ERROR_TEXT = CFG.errorText || 'Error — try again';
    function formatMoney(cents){
      var amount = (cents / 100).toFixed(2);
      var format = CFG.moneyFormat || '{{amount}}';
      var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!m) return amount;
      return format.replace(m[0], amount);
    }
    function findVariant(){
      var key = selectedColor + '||' + selectedSize;
      return variantMap[key] || null;
    }
    function updatePriceUi(){
      currentVariant = findVariant();
      if (!currentVariant) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = SOLD_OUT_TEXT;
        if (stockText) stockText.textContent = STOCK_SELECT_TEXT;
        return;
      }
      if (priceNowEl) priceNowEl.textContent = formatMoney(currentVariant.price);
      var onSale = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
      var savings = onSale ? (currentVariant.compare_at_price - currentVariant.price) : 0;
      if (!compareBox) {
        // Inline layout owns the was-price and the save pill.
        if (priceWasEl) priceWasEl.style.display = onSale ? '' : 'none';
        if (priceWasEl && onSale) priceWasEl.textContent = formatMoney(currentVariant.compare_at_price);
        if (priceSavePill) {
          priceSavePill.style.display = onSale ? '' : 'none';
          if (onSale) priceSavePill.textContent = SAVE_BADGE_PREFIX + ' ' + formatMoney(savings);
        }
      }
      if (saveBadge) {
        saveBadge.style.display = onSale ? '' : 'none';
        if (onSale) saveBadge.textContent = SAVE_BADGE_PREFIX + ' ' + formatMoney(savings);
      }
      // Value comparison layout. The reference is the product tag when that is
      // the chosen source, otherwise the compare-at price — deliberately not the
      // same thing as `onSale`, since a tagged reference is a claim about other
      // retailers and does not require the product to be marked down here.
      // floor, not round, to agree with Liquid's integer divided_by in the
      // server-rendered first paint. The whole reference column hides when there
      // is nothing to compare against, so no divider is left beside an empty gap.
      if (compareBox) {
        // Left half — compare-at price beside yours, and the saving measured
        // against it. floor, not round, to agree with Liquid's integer
        // divided_by in the server-rendered first paint.
        var savePercent = onSale ? Math.floor(savings * 100 / currentVariant.compare_at_price) : 0;
        if (compareAtEl) {
          compareAtEl.style.display = onSale ? '' : 'none';
          if (onSale) compareAtEl.textContent = formatMoney(currentVariant.compare_at_price);
        }
        if (saveCaption) {
          saveCaption.style.display = onSale ? '' : 'none';
          if (onSale) {
            if (SAVINGS_FORMAT === 'amount') {
              saveCaption.textContent = SAVINGS_PREFIX + ' ' + formatMoney(savings);
            } else if (SAVINGS_FORMAT === 'both') {
              saveCaption.textContent = SAVINGS_PREFIX + ' ' + formatMoney(savings) + ' (' + savePercent + '%)';
            } else {
              saveCaption.textContent = SAVINGS_PREFIX + ' ' + savePercent + '%';
            }
          }
        }
        // Right half — the retail reference, on its own. Independent of the
        // markdown above: a product can carry a retail tag without being on
        // sale, and be on sale without carrying one.
        var refPrice = refIsTag ? refFromTag : (currentVariant.compare_at_price || 0);
        var hasRef = refPrice > currentVariant.price;
        if (priceWasEl && hasRef) priceWasEl.textContent = formatMoney(refPrice);
        if (compareCol) compareCol.style.display = hasRef ? '' : 'none';
      }
      if (paymentNoteEl) {
        var installmentAmount = Math.round(currentVariant.price / PAYMENT_INSTALLMENTS);
        paymentNoteEl.textContent = PAYMENT_PREFIX + ' ' + PAYMENT_INSTALLMENTS + ' ' + PAYMENT_MIDDLE + ' ' + formatMoney(installmentAmount) + ' ' + PAYMENT_SUFFIX;
      }
      if (atcBtn) atcBtn.disabled = !currentVariant.available;
      if (atcText) atcText.textContent = currentVariant.available ? ADD_TO_BAG_TEXT : SOLD_OUT_TEXT;
      if (atcPrice) atcPrice.textContent = formatMoney(currentVariant.price);
      if (stockItem && stockText && stockBar) {
        if (!currentVariant.available) {
          stockText.textContent = STOCK_OUT_TEXT;
          stockBar.style.width = '0%';
        } else if (currentVariant.tracked) {
          if (currentVariant.qty <= LOW_STOCK_THRESHOLD) {
            stockText.textContent = currentVariant.qty + ' ' + STOCK_LOW_TEXT;
            stockBar.style.width = Math.max(8, Math.min(100, (currentVariant.qty / LOW_STOCK_THRESHOLD) * 100)) + '%';
          } else {
            stockText.textContent = STOCK_IN_TEXT;
            stockBar.style.width = '100%';
          }
        } else {
          // Inventory isn't tracked in Shopify for this variant, so there's
          // no real quantity to base a percentage on. Using a fixed
          // decorative fill instead of 100% so the bar still reads as a
          // two-tone progress indicator rather than one solid block.
          stockText.textContent = STOCK_IN_TEXT;
          stockBar.style.width = UNTRACKED_FILL_PERCENT + '%';
        }
      }
      if (mainImgWrap && currentVariant.image) {
        var img = mainImgWrap.querySelector('img');
        if (img) img.src = currentVariant.image;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(currentVariant.price);
      if (stickyAtc) stickyAtc.disabled = !currentVariant.available;
      if (stickyAtcText) stickyAtcText.textContent = currentVariant.available ? ADD_TO_BAG_TEXT : SOLD_OUT_TEXT;
      var fbtBasePrice = root.parentNode.querySelector('[data-pdp-fbt-base-price]');
      if (fbtBasePrice) fbtBasePrice.textContent = formatMoney(currentVariant.price);
      updateFbtTotal();
      if (history.replaceState && currentVariant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        history.replaceState({}, '', url);
      }
    }
    if (colorsWrap && colors.length) {
      colors.forEach(function(c, i){
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'pdp-color' + (i === 0 ? ' selected' : '');
        el.style.setProperty('--swatch', swatchMap[c.name.toLowerCase()] || '#ccc');
        el.title = c.name;
        el.addEventListener('click', function(){
          colorsWrap.querySelectorAll('.pdp-color').forEach(function(x){ x.classList.remove('selected'); });
          el.classList.add('selected');
          if (colorLabel) colorLabel.textContent = c.name;
          selectedColor = c.name;
          updatePriceUi();
        });
        colorsWrap.appendChild(el);
      });
      selectedColor = colors[0].name;
      if (colorLabel) colorLabel.textContent = selectedColor;
    }
    if (sizesWrap && sizes.length) {
      var firstAvailable = null;
      sizes.forEach(function(s){
        var key = selectedColor + '||' + s.label;
        var variant = variantMap[key];
        var available = variant ? variant.available : false;
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'pdp-size' + (available ? '' : ' out');
        el.textContent = s.label;
        if (available) {
          if (!firstAvailable) firstAvailable = el;
          el.addEventListener('click', function(){
            sizesWrap.querySelectorAll('.pdp-size').forEach(function(x){ x.classList.remove('selected'); });
            el.classList.add('selected');
            if (sizeLabel) sizeLabel.textContent = s.label;
            selectedSize = s.label;
            updatePriceUi();
          });
        } else {
          el.disabled = true;
        }
        sizesWrap.appendChild(el);
      });
      if (firstAvailable) firstAvailable.click();
      else if (sizes[0] && sizeLabel) { selectedSize = sizes[0].label; sizeLabel.textContent = selectedSize; }
    }
    if (sizeSelect && sizes.length) {
      var firstAvailableSize = null;
      sizes.forEach(function(s){
        var key = selectedColor + '||' + s.label;
        var variant = variantMap[key];
        var available = variant ? variant.available : false;
        var opt = document.createElement('option');
        opt.value = s.label;
        opt.textContent = available ? s.label : (s.label + ' — Sold out');
        opt.disabled = !available;
        if (available && !firstAvailableSize) firstAvailableSize = s.label;
        sizeSelect.appendChild(opt);
      });
      var defaultSize = firstAvailableSize || (sizes[0] && sizes[0].label);
      if (defaultSize) {
        sizeSelect.value = defaultSize;
        selectedSize = defaultSize;
        if (sizeLabel) sizeLabel.textContent = defaultSize;
      }
      sizeSelect.addEventListener('change', function(){
        selectedSize = sizeSelect.value;
        if (sizeLabel) sizeLabel.textContent = selectedSize;
        updatePriceUi();
      });
    }
    updatePriceUi();
    // Image gallery: no visible thumbnails — the hidden thumbs track (if
    // present) only supplies full-size URLs. Navigation happens via the
    // dash pagination row and the lightbox's own prev/next arrows.
    var thumbsTrack = root.querySelector('[data-pdp-thumbs-track]');
    var galleryDotsWrap = root.querySelector('[data-pdp-gallery-dots]');
    var galleryThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var galleryDashes = [];
    function setActiveGalleryIndex(index){
      galleryDashes.forEach(function(d, i){ d.classList.toggle('active', i === index); });
    }
    function showGalleryImage(index){
      var thumb = galleryThumbs[index];
      var img = mainImgWrap ? mainImgWrap.querySelector('img') : null;
      if (img && thumb && thumb.dataset.full) img.src = thumb.dataset.full;
      setActiveGalleryIndex(index);
    }
    if (galleryDotsWrap && galleryThumbs.length > 1) {
      galleryThumbs.forEach(function(thumb, i){
        var dash = document.createElement('button');
        dash.type = 'button';
        if (i === 0) dash.className = 'active';
        dash.setAttribute('aria-label', 'Show image ' + (i + 1));
        dash.addEventListener('click', function(){ showGalleryImage(i); });
        galleryDotsWrap.appendChild(dash);
        galleryDashes.push(dash);
      });
    }
    // Touch swipe support (mobile) — swipe left/right on the main image to
    // move to the next/previous photo. touch-action:pan-y on the element
    // (set in CSS) lets vertical page scrolling pass through untouched
    // while horizontal drags are read here.
    function addSwipeNav(el, onSwipeLeft, onSwipeRight){
      if (!el) return;
      var startX = 0, startY = 0, tracking = false;
      el.addEventListener('touchstart', function(e){
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      el.addEventListener('touchend', function(e){
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          if (dx < 0) onSwipeLeft(); else onSwipeRight();
        }
      }, { passive: true });
    }
    if (galleryThumbs.length > 1) {
      addSwipeNav(mainImgWrap, function(){
        showGalleryImage((currentGalleryIndex() + 1) % galleryThumbs.length);
      }, function(){
        showGalleryImage((currentGalleryIndex() - 1 + galleryThumbs.length) % galleryThumbs.length);
      });
    }
    // Shipping estimate: recompute using the visitor's own local date
    // (the Liquid-rendered version above uses your store's timezone as a
    // fallback for the very first paint) so "today" always means the
    // visitor's actual today, not the store's.
    var shipDateEl = root.querySelector('[data-pdp-ship-date]');
    var shipDateWrap = root.querySelector('[data-pdp-ship-days]');
    if (shipDateEl && shipDateWrap) {
      var daysAhead = parseInt(shipDateWrap.dataset.pdpShipDays, 10) || 2;
      var shipDate = new Date();
      shipDate.setDate(shipDate.getDate() + daysAhead);
      var weekday = shipDate.toLocaleDateString(undefined, { weekday: 'short' });
      var month = shipDate.toLocaleDateString(undefined, { month: 'short' });
      shipDateEl.textContent = weekday + ', ' + month + ' ' + shipDate.getDate();
    }
    // FAQ accordion (each accordion block is its own top-level group)
    var faqGroups = root.querySelectorAll('[data-pdp-faq-group]');
    faqGroups.forEach(function(item){
      var question = item.querySelector('.pdp-faq-question');
      var answer = item.querySelector('.pdp-faq-answer');
      question.addEventListener('click', function(){
        var isOpen = item.classList.contains('open');
        faqGroups.forEach(function(other){
          other.classList.remove('open');
          other.querySelector('.pdp-faq-answer').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
    // Size guide modal
    var sizeChartBtn = root.querySelector('[data-pdp-size-chart]');
    var sizeGuideOverlay = root.querySelector('[data-pdp-size-guide-overlay]');
    var sizeGuideModal = root.querySelector('[data-pdp-size-guide-modal]');
    var sizeGuideClose = root.querySelector('[data-pdp-size-guide-close]');
    function openSizeGuide(){
      if (!sizeGuideModal || !sizeGuideOverlay) return;
      sizeGuideOverlay.style.display = 'block';
      sizeGuideModal.style.display = 'block';
      void sizeGuideModal.offsetHeight;
      sizeGuideOverlay.classList.add('open');
      sizeGuideModal.classList.add('open');
    }
    function closeSizeGuide(){
      if (!sizeGuideModal || !sizeGuideOverlay) return;
      sizeGuideOverlay.classList.remove('open');
      sizeGuideModal.classList.remove('open');
      setTimeout(function(){
        sizeGuideOverlay.style.display = 'none';
        sizeGuideModal.style.display = 'none';
      }, 300);
    }
    if (sizeChartBtn) sizeChartBtn.addEventListener('click', openSizeGuide);
    if (sizeGuideClose) sizeGuideClose.addEventListener('click', closeSizeGuide);
    if (sizeGuideOverlay) sizeGuideOverlay.addEventListener('click', closeSizeGuide);
    // Image zoom / lightbox — a full slider synced with the dash pagination.
    var lightboxOverlay = document.querySelector('[data-pdp-lightbox-overlay]');
    var lightbox = document.querySelector('[data-pdp-lightbox]');
    var lightboxClose = document.querySelector('[data-pdp-lightbox-close]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-pdp-lightbox-img]') : null;
    var lightboxPrev = document.querySelector('[data-pdp-lightbox-prev]');
    var lightboxNext = document.querySelector('[data-pdp-lightbox-next]');
    var lightboxCounter = document.querySelector('[data-pdp-lightbox-counter]');
    var lightboxIndex = 0;
    function currentGalleryIndex(){
      var idx = galleryDashes.findIndex(function(d){ return d.classList.contains('active'); });
      return idx > -1 ? idx : 0;
    }
    function renderLightboxImage(){
      if (!lightboxImg || !galleryThumbs.length) return;
      lightboxIndex = (lightboxIndex + galleryThumbs.length) % galleryThumbs.length;
      var thumb = galleryThumbs[lightboxIndex];
      if (thumb && thumb.dataset.full) lightboxImg.src = thumb.dataset.full;
      if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + galleryThumbs.length;
      // Keep the underlying gallery (main image + dash pagination) synced
      // to whatever the lightbox is currently showing, so closing it lands
      // back on the same photo instead of resetting to the first one.
      showGalleryImage(lightboxIndex);
    }
    // keepIndex is set by the desktop mosaic, which has already decided
    // which photo was clicked. The hero/plus-button path passes nothing and
    // falls back to whatever the dash pagination currently marks active.
    function openLightbox(keepIndex){
      if (!lightbox || !lightboxOverlay) return;
      if (!keepIndex) lightboxIndex = currentGalleryIndex();
      if (lightboxImg) {
        var startThumb = galleryThumbs[lightboxIndex];
        if (startThumb && startThumb.dataset.full) {
          lightboxImg.src = startThumb.dataset.full;
        } else {
          var mainImg = mainImgWrap ? mainImgWrap.querySelector('img') : null;
          if (mainImg) lightboxImg.src = mainImg.src;
        }
      }
      if (lightboxCounter && galleryThumbs.length) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + galleryThumbs.length;
      lightboxOverlay.style.display = 'block';
      lightbox.style.display = 'block';
      if (lightboxClose) lightboxClose.style.display = 'flex';
      if (lightboxPrev) lightboxPrev.style.display = 'flex';
      if (lightboxNext) lightboxNext.style.display = 'flex';
      if (lightboxCounter) lightboxCounter.style.display = 'block';
      void lightbox.offsetHeight;
      lightboxOverlay.classList.add('open');
      lightbox.classList.add('open');
      if (lightboxClose) lightboxClose.classList.add('open');
      if (lightboxPrev) lightboxPrev.classList.add('open');
      if (lightboxNext) lightboxNext.classList.add('open');
      if (lightboxCounter) lightboxCounter.classList.add('open');
    }
    function closeLightbox(){
      if (!lightbox || !lightboxOverlay) return;
      lightboxOverlay.classList.remove('open');
      lightbox.classList.remove('open');
      if (lightboxClose) lightboxClose.classList.remove('open');
      if (lightboxPrev) lightboxPrev.classList.remove('open');
      if (lightboxNext) lightboxNext.classList.remove('open');
      if (lightboxCounter) lightboxCounter.classList.remove('open');
      setTimeout(function(){
        lightboxOverlay.style.display = 'none';
        lightbox.style.display = 'none';
        if (lightboxClose) lightboxClose.style.display = 'none';
        if (lightboxPrev) lightboxPrev.style.display = 'none';
        if (lightboxNext) lightboxNext.style.display = 'none';
        if (lightboxCounter) lightboxCounter.style.display = 'none';
      }, 300);
    }
    var zoomTriggers = root.querySelectorAll('[data-pdp-zoom-trigger]');
    // Wrapped rather than passed directly: addEventListener hands the click
    // event to the listener, and a truthy first argument would be read as
    // keepIndex.
    zoomTriggers.forEach(function(trigger){
      trigger.addEventListener('click', function(){ openLightbox(); });
    });
    // Desktop mosaic — clicking a cell opens the lightbox on that photo.
    // data-index counts images only, matching the hidden thumbs track.
    var gridCells = root.querySelectorAll('[data-pdp-grid-cell]');
    gridCells.forEach(function(cell){
      cell.addEventListener('click', function(){
        var index = parseInt(cell.getAttribute('data-index'), 10);
        lightboxIndex = isNaN(index) ? 0 : index;
        setActiveGalleryIndex(lightboxIndex);
        openLightbox(true);
      });
    });
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxOverlay) lightboxOverlay.addEventListener('click', closeLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener('click', function(){ lightboxIndex--; renderLightboxImage(); });
    if (lightboxNext) lightboxNext.addEventListener('click', function(){ lightboxIndex++; renderLightboxImage(); });
    addSwipeNav(lightbox, function(){ lightboxIndex++; renderLightboxImage(); }, function(){ lightboxIndex--; renderLightboxImage(); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { closeSizeGuide(); closeLightbox(); }
      if (!lightbox || !lightbox.classList.contains('open')) return;
      if (e.key === 'ArrowLeft') { lightboxIndex--; renderLightboxImage(); }
      if (e.key === 'ArrowRight') { lightboxIndex++; renderLightboxImage(); }
    });
    function addToCart(variantId, btn, btnText){
      if (!variantId) return;
      btn.disabled = true;
      var original = btnText.textContent;
      fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(r){ return r.json(); })
        .then(function(){
          btnText.textContent = ADDED_TEXT;
          if (window.MaisonCartDrawer && typeof window.MaisonCartDrawer.open === 'function') {
            if (typeof window.MaisonCartDrawer.refresh === 'function') window.MaisonCartDrawer.refresh();
            window.MaisonCartDrawer.open();
          }
          setTimeout(function(){ btnText.textContent = original; btn.disabled = !currentVariant || !currentVariant.available; }, 1800);
        })
        .catch(function(){
          btnText.textContent = ERROR_TEXT;
          setTimeout(function(){ btnText.textContent = original; btn.disabled = !currentVariant || !currentVariant.available; }, 1800);
        });
    }
    if (atcBtn && atcText) {
      atcBtn.addEventListener('click', function(){
        if (currentVariant) addToCart(currentVariant.id, atcBtn, atcText);
      });
    }
    if (stickyAtc && stickyAtcText) {
      stickyAtc.addEventListener('click', function(){
        if (currentVariant) addToCart(currentVariant.id, stickyAtc, stickyAtcText);
      });
    }
    // Frequently bought together
    var fbtCard = document.querySelector('[data-pdp-fbt]');
    var FBT_ADD_BUTTON_TEMPLATE = CFG.fbtButton || 'Add %count% items to bag';
    function updateFbtTotal(){
      if (!fbtCard) return;
      var total = currentVariant ? currentVariant.price : parseInt(fbtCard.dataset.basePrice, 10);
      fbtCard.querySelectorAll('[data-pdp-fbt-checkbox].checked').forEach(function(cb){
        total += parseInt(cb.dataset.price, 10) || 0;
      });
      var totalEl = fbtCard.querySelector('[data-pdp-fbt-total]');
      if (totalEl) totalEl.textContent = formatMoney(total);
      var addBtn = fbtCard.querySelector('[data-pdp-fbt-add]');
      var checkedCount = fbtCard.querySelectorAll('[data-pdp-fbt-checkbox].checked').length + 1;
      if (addBtn) addBtn.textContent = FBT_ADD_BUTTON_TEMPLATE.replace('%count%', checkedCount);
    }
    if (fbtCard) {
      fbtCard.querySelectorAll('[data-pdp-fbt-checkbox]').forEach(function(cb){
        cb.addEventListener('click', function(){
          cb.classList.toggle('checked');
          updateFbtTotal();
        });
      });
      updateFbtTotal();
      var fbtAddBtn = fbtCard.querySelector('[data-pdp-fbt-add]');
      if (fbtAddBtn) {
        fbtAddBtn.addEventListener('click', function(){
          if (!currentVariant) return;
          var items = [{ id: currentVariant.id, quantity: 1 }];
          fbtCard.querySelectorAll('[data-pdp-fbt-checkbox].checked').forEach(function(cb){
            items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
          });
          fbtAddBtn.disabled = true;
          var original = fbtAddBtn.textContent;
          fetch(CART_ADD_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function(r){ return r.json(); })
            .then(function(){
              fbtAddBtn.textContent = ADDED_TEXT;
              if (window.MaisonCartDrawer && typeof window.MaisonCartDrawer.open === 'function') {
                if (typeof window.MaisonCartDrawer.refresh === 'function') window.MaisonCartDrawer.refresh();
                window.MaisonCartDrawer.open();
              }
              setTimeout(function(){ fbtAddBtn.textContent = original; fbtAddBtn.disabled = false; }, 1800);
            })
            .catch(function(){
              fbtAddBtn.textContent = ERROR_TEXT;
              setTimeout(function(){ fbtAddBtn.textContent = original; fbtAddBtn.disabled = false; }, 1800);
            });
        });
      }
    }
    /* -----------------------------------------------------------------
       Complete the look — each upsell card picks its own size and adds
       that variant. Deliberately not reusing addToCart(): that one
       re-enables its button based on the MAIN product's availability,
       which would disable an upsell button whenever the page's product
       happens to be sold out.
    ----------------------------------------------------------------- */
    function addUpsell(variantId, btn, textEl){
      if (!variantId) return;
      btn.disabled = true;
      var original = textEl.textContent;
      fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(r){ return r.json(); })
        .then(function(){
          textEl.textContent = ADDED_TEXT;
          if (window.MaisonCartDrawer && typeof window.MaisonCartDrawer.open === 'function') {
            if (typeof window.MaisonCartDrawer.refresh === 'function') window.MaisonCartDrawer.refresh();
            window.MaisonCartDrawer.open();
          }
          setTimeout(function(){ textEl.textContent = original; btn.disabled = false; }, 1800);
        })
        .catch(function(){
          textEl.textContent = ERROR_TEXT;
          setTimeout(function(){ textEl.textContent = original; btn.disabled = false; }, 1800);
        });
    }

    root.querySelectorAll('[data-pdp-ctl-card]').forEach(function(card){
      var pills = Array.prototype.slice.call(card.querySelectorAll('[data-pdp-ctl-size]'));
      var sizeSelect = card.querySelector('[data-pdp-ctl-size-select]');
      var addBtn = card.querySelector('[data-pdp-ctl-add]');
      var addText = card.querySelector('[data-pdp-ctl-add-text]');

      // Dropdown variant of the size picker. The option values ARE the variant
      // ids, so keeping the button in sync is a straight copy.
      if (sizeSelect) {
        var syncSelect = function(){
          var id = sizeSelect.value;
          if (addBtn) {
            if (id && id !== '0') { addBtn.dataset.variantId = id; addBtn.disabled = false; }
            else { addBtn.disabled = true; }
          }
        };
        sizeSelect.addEventListener('change', syncSelect);
        syncSelect();
      }

      function selectPill(pill){
        pills.forEach(function(p){ p.classList.toggle('selected', p === pill); });
        if (addBtn && pill.dataset.variantId) addBtn.dataset.variantId = pill.dataset.variantId;
      }

      pills.forEach(function(pill){
        if (pill.disabled) return;
        pill.addEventListener('click', function(){ selectPill(pill); });
      });

      var firstAvailable = pills.filter(function(p){ return !p.disabled; })[0];
      if (firstAvailable) selectPill(firstAvailable);
      // Every size sold out: nothing sensible to add.
      if (pills.length && !firstAvailable && addBtn) addBtn.disabled = true;

      if (addBtn && addText) {
        addBtn.addEventListener('click', function(){
          addUpsell(addBtn.dataset.variantId, addBtn, addText);
        });
      }
    });

    // Sticky bar visibility: show once the main buy row scrolls out of view.
    if (stickyBar) {
      var buyRow = root.querySelector('.pdp-buy-row');
      if (buyRow && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            stickyBar.classList.toggle('visible', !entry.isIntersecting);
          });
        }, { threshold: 0 });
        observer.observe(buyRow);
      }
    }
  }
  document.querySelectorAll('[data-pdp-root]').forEach(initPdp);
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('[data-pdp-root]');
    if (root) initPdp(root);
  });
})();

(function(){
  if (customElements.get('pdp-quickshop-slider')) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function looksLikeColor(name){
    var n = (name || '').toLowerCase();
    return n.indexOf('kleur') > -1 || n.indexOf('colour') > -1 || n.indexOf('color') > -1 || n.indexOf('farbe') > -1;
  }

  class PdpQuickshopSlider extends HTMLElement {
    connectedCallback(){
      this.track = this.querySelector('[data-pqs-track]');
      this.prevBtn = this.querySelector('[data-pqs-prev]');
      this.nextBtn = this.querySelector('[data-pqs-next]');
      this.progress = this.querySelector('[data-pqs-progress]');
      this.thumb = this.querySelector('[data-pqs-progress-thumb]');
      this.overlay = this.querySelector('[data-pqs-overlay]');
      this.menu = this.querySelector('[data-pqs-menu]');
      this.live = this.querySelector('[data-pqs-live]');

      this.cartAddUrl = this.dataset.cartAddUrl;
      this.cartUrl = this.dataset.cartUrl;
      this._selection = {};
      this._product = null;

      this._bindRail();
      this._bindClicks();
      this._bindMenuChrome();
      this._update();
    }

    disconnectedCallback(){
      if (this._ro) this._ro.disconnect();
      if (this._keydown) document.removeEventListener('keydown', this._keydown);
      document.body.style.overflow = '';
    }

    /* ---------- rail ---------- */
    _bindRail(){
      if (!this.track) return;
      this.track.addEventListener('scroll', function(){
        if (this._raf) return;
        this._raf = requestAnimationFrame(function(){ this._raf = null; this._update(); }.bind(this));
      }.bind(this));
      if (this.prevBtn) this.prevBtn.addEventListener('click', function(){ this._page(-1); }.bind(this));
      if (this.nextBtn) this.nextBtn.addEventListener('click', function(){ this._page(1); }.bind(this));
      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(function(){ this._update(); }.bind(this));
        this._ro.observe(this.track);
      } else {
        window.addEventListener('resize', function(){ this._update(); }.bind(this));
      }
    }

    _page(direction){
      var slide = this.track.querySelector('.pqs-slide');
      var step = slide ? slide.getBoundingClientRect().width : this.track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      this.track.scrollBy({ left: direction * (step + gap), behavior: 'smooth' });
    }

    // thumbWidth = viewport / content * trackWidth
    _update(){
      if (!this.track) return;
      var viewport = this.track.clientWidth;
      var content = this.track.scrollWidth;
      var maxScroll = content - viewport;
      var overflows = maxScroll > 1;

      if (this.prevBtn) this.prevBtn.hidden = !overflows || this.track.scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.hidden = !overflows || this.track.scrollLeft >= maxScroll - 1;

      if (this.progress) {
        this.progress.hidden = !overflows;
        if (overflows && this.thumb) {
          var trackWidth = this.progress.clientWidth;
          var thumbWidth = Math.max(20, (viewport / content) * trackWidth);
          var ratio = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
          ratio = Math.min(1, Math.max(0, ratio));
          this.thumb.style.width = thumbWidth + 'px';
          this.thumb.style.transform = 'translateX(' + (ratio * (trackWidth - thumbWidth)) + 'px)';
        }
      }
    }

    /* ---------- card clicks ---------- */
    _bindClicks(){
      this.addEventListener('click', function(evt){
        var swatch = evt.target.closest('[data-pqs-swatch]');
        if (swatch && this.contains(swatch)) {
          evt.preventDefault();
          this._selectSwatch(swatch);
          return;
        }

        var bag = evt.target.closest('[data-pqs-quickadd]');
        if (bag && this.contains(bag)) {
          evt.preventDefault();
          if (bag.disabled) return;
          var bagCard = bag.closest('[data-pqs-card]');
          if (!bagCard) return;
          if (bagCard.dataset.singleVariant === 'true') {
            this._addToCart(bagCard.dataset.variantId, { mode: 'card', button: bag });
          } else {
            this._openFromCard(bagCard, bag);
          }
          return;
        }

        var opener = evt.target.closest('[data-pqs-open]');
        if (!opener || !this.contains(opener)) return;
        // Modifier / middle clicks keep the normal "open the product page" behaviour.
        if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.button !== 0) return;
        var card = opener.closest('[data-pqs-card]');
        if (!card) return;
        evt.preventDefault();
        this._openFromCard(card, opener);
      }.bind(this));
    }

    _openFromCard(card, trigger){
      var jsonEl = card.querySelector('[data-pqs-json]');
      if (!jsonEl) { window.location.href = card.dataset.productUrl; return; }
      var product;
      try { product = JSON.parse(jsonEl.textContent); }
      catch (e) { window.location.href = card.dataset.productUrl; return; }
      var active = card.querySelector('[data-pqs-swatch][aria-pressed="true"]');
      this._openMenu(product, trigger, active ? active.dataset.value : null);
    }

    // srcset outranks src, so it has to go before swapping the photo.
    _selectSwatch(swatch){
      var card = swatch.closest('[data-pqs-card]');
      if (!card) return;
      card.querySelectorAll('[data-pqs-swatch]').forEach(function(other){
        other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
      });
      var image = swatch.getAttribute('data-image');
      var img = card.querySelector('.pqs-img');
      if (image && img) { img.removeAttribute('srcset'); img.src = image; }
    }

    /* ---------- quick-shop menu ---------- */
    _bindMenuChrome(){
      if (!this.overlay) return;
      var close = this.querySelector('[data-pqs-close]');
      if (close) close.addEventListener('click', function(){ this._closeMenu(); }.bind(this));
      this.overlay.addEventListener('click', function(evt){
        if (evt.target === this.overlay) this._closeMenu();
      }.bind(this));
      var submit = this.querySelector('[data-pqs-submit]');
      if (submit) {
        submit.addEventListener('click', function(){
          if (submit.disabled || !submit.dataset.variantId) return;
          this._addToCart(submit.dataset.variantId, { mode: 'menu' });
        }.bind(this));
      }
    }

    _openMenu(product, trigger, preselectColor){
      if (!this.overlay || !this.menu) return;
      this._product = product;
      this._trigger = trigger;
      this._selection = {};

      var title = this.querySelector('[data-pqs-menu-title]');
      if (title) title.textContent = product.title;
      var view = this.querySelector('[data-pqs-menu-view]');
      if (view) view.href = product.url;
      var img = this.querySelector('[data-pqs-menu-image]');
      if (img) { img.src = product.featured_image || ''; img.alt = product.title; img.hidden = !product.featured_image; }

      // Preselect the colour the shopper was already looking at, plus any
      // option with only one value. Size stays open — picking it is the point.
      product.options.forEach(function(option, index){
        if (option.values.length === 1) {
          this._selection[option.name] = option.values[0].name;
        } else if (preselectColor && index === product.color_index) {
          var hit = option.values.filter(function(v){ return v.name === preselectColor; })[0];
          if (hit) this._selection[option.name] = hit.name;
        }
      }.bind(this));

      this._renderOptions();
      this._updateMatch();

      this.overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      var focusables = this.menu.querySelectorAll(FOCUSABLE);
      if (focusables.length) focusables[0].focus();

      this._keydown = function(evt){
        if (evt.key === 'Escape') { evt.preventDefault(); this._closeMenu(); return; }
        if (evt.key !== 'Tab') return;
        var items = Array.prototype.slice.call(this.menu.querySelectorAll(FOCUSABLE));
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
        else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
      }.bind(this);
      document.addEventListener('keydown', this._keydown);
    }

    _closeMenu(){
      if (!this.overlay) return;
      this.overlay.hidden = true;
      document.body.style.overflow = '';
      if (this._keydown) { document.removeEventListener('keydown', this._keydown); this._keydown = null; }
      var status = this.querySelector('[data-pqs-status]');
      if (status) { status.textContent = ''; status.removeAttribute('data-tone'); }
      var submit = this.querySelector('[data-pqs-submit]');
      if (submit && submit.dataset.originalText) submit.textContent = submit.dataset.originalText;
      if (this._trigger) { this._trigger.focus(); this._trigger = null; }
    }

    _renderOptions(){
      var wrap = this.querySelector('[data-pqs-menu-options]');
      if (!wrap || !this._product) return;
      wrap.innerHTML = '';

      this._product.options.forEach(function(option, index){
        var isColor = index === this._product.color_index || looksLikeColor(option.name);

        var group = document.createElement('div');
        group.className = 'pqs-optgroup';

        var label = document.createElement('span');
        label.className = 'pqs-optgroup-label';
        label.textContent = option.name;
        group.appendChild(label);

        var values = document.createElement('div');
        values.className = 'pqs-optvalues' + (isColor ? ' pqs-optvalues--color' : '');
        values.setAttribute('role', 'group');
        values.setAttribute('aria-label', option.name);

        option.values.forEach(function(value){
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pqs-optvalue' + (isColor ? ' pqs-optvalue--color' : '');
          btn.textContent = value.name;
          btn.dataset.optionName = option.name;
          btn.dataset.value = value.name;
          if (isColor) {
            btn.title = value.name;
            btn.setAttribute('aria-label', value.name);
            if (value.swatch) btn.style.setProperty('--pqs-swatch-color', value.swatch);
            if (value.swatch_image) btn.style.setProperty('--pqs-swatch-image', 'url(' + value.swatch_image + ')');
          }
          btn.setAttribute('aria-pressed', this._selection[option.name] === value.name ? 'true' : 'false');
          btn.addEventListener('click', function(){
            if (btn.disabled) return;
            this._selection[option.name] = value.name;
            this._renderOptions();
            this._updateMatch();
          }.bind(this));
          values.appendChild(btn);
        }.bind(this));

        group.appendChild(values);
        wrap.appendChild(group);
      }.bind(this));

      this._markUnavailable();
    }

    // Strike through values that cannot produce a buyable variant given the
    // rest of the current selection.
    _markUnavailable(){
      var product = this._product;
      if (!product) return;
      var self = this;
      product.options.forEach(function(option, index){
        option.values.forEach(function(value){
          var possible = product.variants.some(function(variant){
            if (!variant.available) return false;
            if (variant.options[index] !== value.name) return false;
            return product.options.every(function(other, otherIndex){
              if (otherIndex === index) return true;
              var chosen = self._selection[other.name];
              if (!chosen) return true;
              return variant.options[otherIndex] === chosen;
            });
          });
          var btn = self.querySelector(
            '[data-pqs-menu-options] .pqs-optvalue[data-option-name="' +
            CSS.escape(option.name) + '"][data-value="' + CSS.escape(value.name) + '"]'
          );
          if (btn) btn.disabled = !possible;
        });
      });
    }

    _updateMatch(){
      var product = this._product;
      var submit = this.querySelector('[data-pqs-submit]');
      var priceEl = this.querySelector('[data-pqs-menu-price]');
      var status = this.querySelector('[data-pqs-status]');
      var img = this.querySelector('[data-pqs-menu-image]');
      if (!product || !submit) return;

      var selected = product.options.map(function(opt){ return this._selection[opt.name]; }.bind(this));
      var complete = selected.every(function(v){ return v !== undefined; });

      function setStatus(text, tone){
        if (!status) return;
        status.textContent = text || '';
        if (tone) { status.setAttribute('data-tone', tone); } else { status.removeAttribute('data-tone'); }
      }

      function renderPrice(variant){
        if (!priceEl) return;
        priceEl.innerHTML = '';
        if (!variant) return;
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (onSale) {
          var was = document.createElement('span');
          was.className = 'pqs-was';
          was.textContent = variant.compare_at_price_formatted;
          priceEl.appendChild(was);
        }
        var now = document.createElement('span');
        now.className = 'pqs-now' + (onSale ? ' pqs-now--sale' : '');
        now.textContent = variant.price_formatted;
        priceEl.appendChild(now);
      }

      if (!complete) {
        submit.disabled = true;
        submit.dataset.variantId = '';
        renderPrice(product.variants[0]);
        var missing = product.options.filter(function(opt){
          return this._selection[opt.name] === undefined;
        }.bind(this)).map(function(opt){ return opt.name.toLowerCase(); }).join(' + ');
        setStatus((this.dataset.selectPrompt || 'Select') + ' ' + missing, null);
        return;
      }

      var match = product.variants.filter(function(variant){
        return variant.options.length === selected.length &&
          variant.options.every(function(value, i){ return value === selected[i]; });
      })[0];

      if (!match) {
        submit.disabled = true;
        submit.dataset.variantId = '';
        setStatus(this.dataset.unavailableLabel || 'Unavailable.', 'error');
        return;
      }

      renderPrice(match);
      if (img && match.image) { img.removeAttribute('srcset'); img.src = match.image; }

      if (!match.available) {
        submit.disabled = true;
        submit.dataset.variantId = '';
        setStatus(this.dataset.soldoutLabel || 'Sold out.', 'error');
        return;
      }

      submit.disabled = false;
      submit.dataset.variantId = match.id;
      setStatus('', null);
    }

    /* ---------- cart ----------
       Deliberately its own add call rather than the PDP's addToCart(): that
       one re-enables its button from the MAIN product's availability, which
       would disable an upsell button whenever this page's product is sold out.
    -------------------------------------------------------------------- */
    _addToCart(variantId, ctx){
      if (!variantId || !this.cartAddUrl) return;
      var addUrl = this.cartAddUrl.replace(/\/$/, '') + '.js';

      if (ctx.mode === 'card') this._setBagState(ctx.button, 'loading');
      if (ctx.mode === 'menu') this._setSubmitState('loading');

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(res){ return res.json().then(function(data){ return { ok: res.ok, data: data }; }); })
        .then(function(result){
          if (!result.ok) throw new Error((result.data && result.data.description) || this.dataset.errorLabel || 'Error');
          return this._refreshCart().then(function(){ return result.data; });
        }.bind(this))
        .then(function(added){
          if (ctx.mode === 'card') this._setBagState(ctx.button, 'success');
          if (ctx.mode === 'menu') {
            this._setSubmitState('success');
            setTimeout(function(){ this._closeMenu(); }.bind(this), 900);
          }
          // Theme cart drawer, same hook the rest of this section uses.
          if (window.MaisonCartDrawer) {
            if (typeof window.MaisonCartDrawer.refresh === 'function') window.MaisonCartDrawer.refresh();
            if (typeof window.MaisonCartDrawer.open === 'function') window.MaisonCartDrawer.open();
          }
          this._announce((added && added.product_title ? added.product_title : 'Item') + ' — ' + (this.dataset.addedLabel || 'added'));
        }.bind(this))
        .catch(function(err){
          if (ctx.mode === 'card') this._setBagState(ctx.button, 'error');
          if (ctx.mode === 'menu') this._setSubmitState('error', err.message);
          this._announce(err.message || this.dataset.errorLabel || 'Error');
        }.bind(this));
    }

    _refreshCart(){
      if (!this.cartUrl) return Promise.resolve();
      return fetch(this.cartUrl.replace(/\/$/, '') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(res){ return res.json(); })
        .then(function(cart){
          document.querySelectorAll('[data-cart-count], .cart-count-bubble').forEach(function(el){
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        })
        .catch(function(){});
    }

    _setBagState(btn, state){
      if (!btn) return;
      btn.dataset.state = state;
      btn.disabled = state === 'loading' || state === 'success' || state === 'error';
      if (state === 'success' || state === 'error') {
        setTimeout(function(){ btn.dataset.state = ''; btn.disabled = false; }, 1400);
      }
    }

    _setSubmitState(state, message){
      var submit = this.querySelector('[data-pqs-submit]');
      var status = this.querySelector('[data-pqs-status]');
      if (!submit) return;
      submit.dataset.originalText = submit.dataset.originalText || submit.textContent;
      if (state === 'loading') {
        submit.disabled = true;
        submit.textContent = this.dataset.addingLabel || 'Adding…';
      } else if (state === 'success') {
        submit.textContent = this.dataset.addedLabel || 'Added';
        if (status) { status.textContent = this.dataset.addedLabel || 'Added'; status.setAttribute('data-tone', 'success'); }
      } else if (state === 'error') {
        submit.disabled = false;
        submit.textContent = submit.dataset.originalText;
        if (status) { status.textContent = message || this.dataset.errorLabel || 'Error'; status.setAttribute('data-tone', 'error'); }
      }
    }

    _announce(message){
      if (!this.live) return;
      this.live.textContent = '';
      requestAnimationFrame(function(){ this.live.textContent = message; }.bind(this));
    }
  }

  customElements.define('pdp-quickshop-slider', PdpQuickshopSlider);
})();